import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Row } from "reactstrap";
import ButtonComponent from "../../../components/ButtonComponent";
import InputComponent from "../../../components/InputComponent";
import SelectComponent from "../../../components/SelectComponent";
import Routes from "../../../helpers/Routes";
import Toast from "../../../helpers/Toast";
import { Utilities } from "../../../helpers/Utilities";
import { AssistanceDTO } from "../../../models/Assistance/AssistanceDTO";
import { CreateAssistanceDTO, CreateAssistanceDTOSchema } from "../../../models/Assistance/CreateAssistanceDTO";
import { AssistanceService } from "../../../services/AssistanceService";
import { EquipmentService } from "../../../services/EquipmentService";
import { TimeHistoryDTO } from "../../../models/TimeHistory/TimeHistoryDTO";
import { useIntl } from "react-intl";
import { useAvailableModulesContext } from "../../../context/AvailableModulesContext";
import { RenderCountersInputs } from "../RenderCountersInputs";

export type SelectItemsProps = {
    label: string;
    value: string;
};

export default function AssistanceWorkshopCreateB() {
    //Pagina
    const { equipmentErpId } = useParams<{ equipmentErpId: string }>();
    const [isLoadingAssistance, setIsLoadingAssistance] = useState<boolean>(false);
    const assistanceService = new AssistanceService();
    const equipmentService = new EquipmentService();
    const [equipmentNotFound, setEquipmentNotFound] = useState<boolean>(false);
    const [assistance, setAssistance] = useState<AssistanceDTO>({} as AssistanceDTO);
    const navigate = useNavigate();
    const [isLoadingUpdateAssistance, setIsLoadingUpdateAssistance] = useState<boolean>(false);
    const [timeHistory, setTimeHistory] = useState<TimeHistoryDTO>({ counter1: 0, counter2: 0, counter3: 0 } as TimeHistoryDTO);

    const [selectedAssistanceType, setSelectedAssistanceType] = useState<string>(Utilities.LoadParameterFromURLQuery("assistanceType", "string", ""));
    const [assistanceTypesComponent, setAssistanceTypesComponent] = useState<SelectItemsProps[]>([]);

    const { availableModules, assistanceTypes, counterOptions } = useAvailableModulesContext();
    const [isActiveCountersModule, setIsActiveCountersModule] = useState<boolean>(false);

    useEffect(() => {
        if (availableModules.includes("IsActiveCountersModule")) {
            setIsActiveCountersModule(true);
        }
    }, [availableModules]);


    //obter tipo de assistencia
    const getAssistanceTypes = async () => {
        const list: SelectItemsProps[] = [];

        assistanceTypes.forEach((element) => {
            var item: SelectItemsProps = {
                value: element,
                label: element,
            };
            list.push(item);
        });

        setAssistanceTypesComponent(list);
    };

    useEffect(() => {
        getAssistance();
        getAssistanceTypes();
    }, []);

    const getAssistance = async () => {
        setIsLoadingAssistance(true);
        var response = await equipmentService.GetByIdErp(equipmentErpId ?? "0");
        setIsLoadingAssistance(false);

        if (response.success !== true || response.obj == null) {
            setEquipmentNotFound(true);
            Toast.Show("error", response.message);
            return;
        }

        setAssistance({
            ...assistance,
            equipment: response.obj,
            date: new Date(),
        });

        //Por defeito o estado é inicializado no 1,
        //por isso não é necessario fazer a mesma coisa de cima
    };

    const createAssistance = async () => {
        var object: CreateAssistanceDTO = {
            id: assistance.id,
            date: assistance.date,
            description: assistance.description,
            notes: assistance.notes,
            equipmentErpId: assistance.equipment != null ? assistance.equipment.erpId : "",
            equipmentName: assistance.equipment != null ? assistance.equipment.name : null,
            equipmentNumSerie: assistance.equipment != null ? assistance.equipment.serialNumber : null,
            equipmentBrand: assistance.equipment != null ? assistance.equipment.brand : null,
            equipmentModel: assistance.equipment != null ? assistance.equipment.model : null,
            projectErpId: assistance.project != null ? assistance.project.erpId : null,
            clientErpId: assistance?.equipment?.client?.erpId ?? null,
            typeDoc: null,
            numDoc: null,
            serie: null,
            clientId: assistance?.equipment?.client?.id ?? null,
            counter1: timeHistory.counter1 || 0,
            counter2: timeHistory.counter2 || 0,
            counter3: timeHistory.counter3 || 0,
            unit1: timeHistory.unit1,
            unit2: timeHistory.unit2,
            unit3: timeHistory.unit3,
            assistanceType: selectedAssistanceType || "Reparação",
            stockEntryDocumentErpId: null,
            budgetSellingPrice: assistance.budgetSellingPrice ?? null,
            budgetCostPrice: assistance.budgetCostPrice ?? null
        };

        var responseValidate = CreateAssistanceDTOSchema.validate(object, {
            allowUnknown: true,
        });

        if (responseValidate.error != null) {
            var message = responseValidate.error!.message;
            Toast.Show("error", message);
            return false;
        }

        setIsLoadingUpdateAssistance(true);
        var response = await assistanceService.CreateInDbAndErp(object);
        setIsLoadingUpdateAssistance(false);

        if (response.success !== true) {
            Toast.Show("error", response.message);
            return false;
        }

        Toast.Show("success", "Assistência ativada com sucesso!");

        //TODO: Se for sucesso, devemos de navegar para a pagina de editar?
        //Falta criar a rota e a pagina
        //navigate(`/workshop/assistance/edit/${response.obj}`);
        // alert("TODO: Navegar para a pagina de editar?")
        navigate(`${Routes.oficina.details}/${response.obj}`);
        return true;
    };

    const intl = useIntl();

    return (
        <>
            {/* Se o pedido para obter a assistencia não retornou nada */}
            {equipmentNotFound === true && (
                <div>
                    <span className="error">O equipamento selecionado não foi encontrado.</span>
                </div>
            )}

            <Row style={{ margin: "0px", padding: "0px" }}>
                <SelectComponent
                    xl={6}
                    lg={6}
                    md={6}
                    sm={6}
                    xs={6}
                    style={{ width: "100%", height: "43px" }}
                    label={"Tipo de Assistência"}
                    selectedItemValue={selectedAssistanceType}
                    items={assistanceTypesComponent}
                    onChange={(t: string) => {
                        setSelectedAssistanceType(t);
                    }}
                />
            </Row >

            {/*Estado 1 - data + equipamento + cliente*/}
            <Row style={{ margin: "0px", padding: "0px" }}>
                <InputComponent
                    xl={2}
                    lg={3}
                    md={5}
                    sm={6}
                    xs={6}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={assistance?.equipment?.carPlate}
                    label={"Matricula"}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistance}
                />

                <InputComponent
                    xl={4}
                    lg={3}
                    md={5}
                    sm={6}
                    xs={6}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={assistance?.equipment?.client?.name}
                    label={"Cliente Equipamento"}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistance}
                />
            </Row>

            <Row style={{ margin: "0px", padding: "0px" }}>
                <InputComponent
                    xl={2}
                    lg={3}
                    md={5}
                    sm={6}
                    xs={6}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={assistance?.equipment?.serialNumber}
                    label={"Nº Série"}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistance}
                />
                <InputComponent
                    xl={2}
                    lg={3}
                    md={5}
                    sm={6}
                    xs={6}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={assistance?.equipment?.brand}
                    label={"Marca"}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistance}
                />

                <InputComponent
                    xl={2}
                    lg={3}
                    md={5}
                    sm={6}
                    xs={6}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={assistance?.equipment?.model}
                    label={"Modelo"}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistance}
                />
            </Row>

            <Row style={{ margin: "0px", padding: "0px" }}>
                <InputComponent
                    xl={2}
                    lg={3}
                    md={5}
                    sm={6}
                    xs={6}
                    style={{ width: "100%" }}
                    type={"date"}
                    value={assistance?.date != null ? Utilities.formatDateYYYYMMDD(assistance?.date) : ""}
                    label={"Dia"}
                    readOnly={false}
                    showLoadingSkeleton={isLoadingAssistance}
                    onChange={(t: string) => {
                        setAssistance({
                            ...assistance,
                            date: new Date(`${t}T${Utilities.GetTimeFromDateTime(assistance?.date)}`),
                        });
                    }}
                />

                <InputComponent
                    xl={2}
                    lg={3}
                    md={5}
                    sm={6}
                    xs={6}
                    style={{ width: "100%" }}
                    type={"time"}
                    value={assistance?.date != null ? Utilities.GetTimeFromDateTime(assistance?.date) : ""}
                    label={"Hora"}
                    readOnly={false}
                    showLoadingSkeleton={isLoadingAssistance}
                    onChange={(t: string) => {
                        setAssistance({
                            ...assistance,
                            date: new Date(`${Utilities.formatDate(assistance?.date)}T${t}`),
                        });
                    }}
                />
            </Row>

            {/* Estado 2 - Contadores */}
            {isActiveCountersModule && (
                <>
                    <label style={{ margin: "0px", padding: "13px", fontWeight: "bold" }}>
                        {intl.formatMessage({ id: "Screens.AssistanceCreateB.CountersTitle" })}
                    </label>
                    <Row style={{ margin: "0px", padding: "0px" }}>
                        {RenderCountersInputs(counterOptions, timeHistory, setTimeHistory)}
                    </Row>
                </>
            )}


            {/* Estado 3 - Descrições */}
            <Row style={{ margin: "0px", padding: "0px" }}>
                <InputComponent
                    xl={6}
                    lg={9}
                    md={10}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"textArea"}
                    value={assistance.description}
                    label={"Descrição do Serviço"}
                    readOnly={false}
                    onChange={(t: string) => {
                        setAssistance({ ...assistance, description: t });
                    }}
                />
            </Row>
            <Row style={{ margin: "0px", padding: "0px" }}>
                <InputComponent
                    xl={6}
                    lg={9}
                    md={10}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"textArea"}
                    value={assistance.notes}
                    label={"Observações"}
                    readOnly={false}
                    onChange={(t: string) => {
                        setAssistance({ ...assistance, notes: t });
                    }}
                />
            </Row>

            {/* Estado 4 - Ativar Assistência */}
            <Row style={{ margin: "1rem 0px 0px 0px" }}>
                <Col xl={2} lg={6} md={6} sm={12} xs={12}>
                    <ButtonComponent
                        text={intl.formatMessage({ id: "AssistanceWorkshopCreateB.CreateAssistance" })}
                        style={{ width: "100%", height: "3em" }}
                        onClick={createAssistance}
                        disabled={equipmentNotFound === true || isLoadingUpdateAssistance === true}
                    />
                </Col>
            </Row>
        </>
    );
}
